import React, { useEffect } from "react";
import { useState } from "react";
import * as Axios from "axios";
import "./SnippetEditor.scss";
import ErrorMessage from "../misc/ErrorMessage";
import domain from "../../util/domain";
export default function SnippetEditor({
  getSnippets,
  setSnippetEditorOpen,
  editSnippetData,
}) {
  const [editorTittle, setEditorTitle] = useState("");
  const [editorDescription, setEditorDescription] = useState("");
  const [editorCode, setEditorCode] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    if (editSnippetData) {
      setEditorTitle(editSnippetData.title ? editSnippetData.title : "");
      setEditorDescription(
        editSnippetData.description ? editSnippetData.description : ""
      );
      setEditorCode(editSnippetData.code ? editSnippetData.code : "");
    }
  }, [editSnippetData]);

  async function saveSnippet(e) {
    e.preventDefault();

    const snippetData = {
      title: editorTittle ? editorTittle : undefined,
      description: editorDescription ? editorDescription : undefined,
      code: editorCode ? editorCode : undefined,
    };
    try {
      if (!editSnippetData) await Axios.post(`${domain}/snippet/`, snippetData);
      else
        await Axios.put(
          `${domain}/snippet/${editSnippetData._id}`,
          snippetData
        );
    } catch (err) {
      if (err.response) {
        if (err.response.data.errorMessage) {
          setErrorMessage(err.response.data.errorMessage);
        }
      }
      return;
    }

    getSnippets();
    closeEditor();
  }

  function closeEditor() {
    setSnippetEditorOpen(false);
    setEditorCode("");
    setEditorDescription("");
    setEditorTitle("");
  }
  return (
    <div className="snippet-editor">
      <form className="form" onSubmit={saveSnippet}>
        {errorMessage && (
          <ErrorMessage
            message={errorMessage}
            clear={() => setErrorMessage(null)}
          />
        )}
        <label htmlFor="editor-title "> Title</label>;
        <input
          id="editor-title"
          type="text"
          value={editorTittle}
          onChange={(e) => setEditorTitle(e.target.value)}
        />
        <label htmlFor="editor-description"> Description</label>;
        <input
          id="editor-description"
          type="text"
          value={editorDescription}
          onChange={(e) => setEditorDescription(e.target.value)}
        />
        <label htmlFor="editor-code "> Code</label>;
        <textarea
          id=" editor-code"
          value={editorCode}
          onChange={(e) => setEditorCode(e.target.value)}
        />
        <button className="btn-save" type="submit">
          Save{" "}
        </button>
        <button className="btn-cancel" type="button" onClick={closeEditor}>
          {" "}
          Cancel{" "}
        </button>
      </form>
    </div>
  );
}
